import {
  headline,
  spacer,
  text,
  field,
  button,
  voucher,
  wheel,
  image,
} from '@components/Widgets/_contentItems/all'
import { settings, styling } from '@components/Widgets/Templates/_base'
import { type, maxWidth, position } from '@meta/widget/options'
import { tag, typeTag } from '@meta/widget/templates'

const info = {
  name: 'Black Friday: Spin & Save',
  templateID: '12',
  description: 'Ready to elevate your Black Friday sales with an engaging, interactive experience? Meet our Spin & Save: Black Friday Specials Await widget template! This interactive tool is designed to boost user engagement, increase conversions, and provide your customers with a thrilling shopping experience. With discounts, special offers, and free gifts at stake, your visitors won’t want to leave without spinning the wheel!.',
  tags: [typeTag.GAMIFICATION, tag.LEAD_GENERATION, tag.COUPONS_OFFERS],
}

const json = {
  id: 2345321,
  templateID: info.templateID,
  type: type.FORTUNE_WHEEL,
  name: info.name,
  active: true,
  settings: (() => {
    const customSettings = { ...settings }
    customSettings.position = position.CENTER
    customSettings.ribbonColor = '#f8f9e8'
    customSettings.ribbonBgColor = '#000000'
    customSettings.wheel = (() => {
      const customWheel = JSON.parse(JSON.stringify(wheel))
      Object.assign(customWheel.styling, {
        color: 'rgba(254, 254, 254, 1)',
        borderColor: 'rgb(0, 0, 0)',
        backgroundColor: 'rgba(0, 0, 0, 1)',
        fontFamily: 'Inter',
        fontWeight: 'bold',
        secondaryBackgroundColor: 'rgba(133, 0, 27, 1)',
      })
      customWheel.settings.label = 'Fortune Wheel'
      customWheel.content.prizes = [
        {
          id: 'anpiafc',
          label: 'Free Shipping',
          value: 'CODE-FREE-SHIPPING',
          weight: 10,
        },
        {
          id: 'e61mxtp',
          label: '10% OFF',
          value: 'CODE-TEN-OFF',
          weight: 10,
        },
        {
          id: '4vdmeum',
          label: 'So close!',
          value: 'TRY-AGAIN',
          weight: 10,
        },
        {
          id: '9bft7gp',
          label: '5% OFF',
          value: 'CODE-FIVE-OFF',
          weight: 10,
        },
        {
          id: '2wogr3q',
          label: 'Free Gift',
          value: 'CODE-FREE-VOUCHER',
          weight: 10,
        },
        {
          id: 'yj1m3co',
          label: 'Free Shipping',
          value: 'CODE-FREE-SHIPPING',
          weight: 10,
        },
        {
          id: 'ltdpcbx',
          label: 'So close!',
          value: 'TRY-AGAIN',
          weight: 10,
        },
        {
          id: 'tmeyvpj',
          label: '10% OFF',
          value: 'CODE-TEN-OFF',
          weight: 10,
        },
        {
          id: 't4htj9c',
          label: 'Free Shipping',
          value: 'CODE-FREE-SHIPPING',
          weight: 10,
        },
        {
          id: 'vy6xbsv',
          label: '5% OFF',
          value: 'CODE-FIVE-OFF',
          weight: 10,
        },
        {
          id: '92mqlra',
          label: 'Free Gift',
          value: 'CODE-FREE-GIFT',
          weight: 10,
        },
        {
          id: 'lw4042m',
          label: '5% OFF',
          value: 'CODE-FIVE-OFF',
          weight: 10,
        },
      ]
      return customWheel
    })()

    return customSettings
  })(),
  styling: (() => {
    const customStyling = { ...styling } // Ensure we're working with a copy of the styling
    customStyling.maxWidth = maxWidth.EXTRA_LARGE
    customStyling.borderRadius = '40px'
    customStyling.backgroundColor = '#000000'
    customStyling.backgroundImage = 'url("https://assets.onvocado.com/templates/black_friday-bg.jpg")'

    return customStyling
  })(),
  steps: [
    {
      id: '22fbuuc',
      contentItems: [
        (() => {
          const customImage = JSON.parse(JSON.stringify(image))
          customImage.content.url = 'https://assets.onvocado.com/templates/black_friday_tag.png'
          Object.assign(customImage.styling, {
            backgroundSize: 'cover',
            backgroundColor: 'rgba(0, 0, 0, 0)',
            backgroundPosition: 'center',
          })
          return customImage
        })(),
        // spacer
        (() => {
          const customSpacer = JSON.parse(JSON.stringify(spacer))
          customSpacer.styling.padding = '8px'
          return customSpacer
        })(),
        (() => {
          const customHeadline = JSON.parse(JSON.stringify(headline))
          customHeadline.content.text = 'Spin & Save: Black Friday Specials Await!'
          Object.assign(customHeadline.styling, {
            fontFamily: 'Inter',
            fontSize: '32px',
            fontWeight: 'bold',
            color: 'rgba(255, 255, 255, 1)',
            textAlign: 'left',
          })
          return customHeadline
        })(),
        // text
        (() => {
          const customText = JSON.parse(JSON.stringify(text))
          customText.content.text = '<p>Black Friday just got more exciting! <strong>Spin the wheel</strong> for a chance to win incredible discounts, free gifts, and more! Ready to play?</p>'
          Object.assign(customText.styling, {
            color: 'rgba(255, 255, 255, 1)',
            fontSize: '18px',
            textAlign: 'left',
            fontFamily: 'Inter',
            fontWeight: '400',
          })
          return customText
        })(),
        // field
        (() => {
          const customField = JSON.parse(JSON.stringify(field))
          customField.content.title = 'Email'
          customField.content.placeholder = 'Your Email'
          Object.assign(customField.styling, {
            color: 'rgb(13, 40, 20)',
            fontSize: '17px',
            textAlign: 'left',
            fontFamily: 'Inter',
            fontWeight: '400',
            borderColor: 'rgba(255, 255, 255, 1)',
            borderWidth: '2px',
            borderRadius: '2px',
            backgroundColor: 'rgba(254, 254, 254, 1)',
          })
          customField.settings.type = 'email'
          customField.settings.label = 'Email address'
          customField.settings.required = true

          return customField
        })(),
        // button
        (() => {
          const customBtn = JSON.parse(JSON.stringify(button))
          customBtn.content.text = 'Let\'s Spin'
          Object.assign(customBtn.styling, {
            color: 'rgba(255, 255, 255, 1)',
            fontSize: '18px',
            fontFamily: 'Inter',
            fontWeight: 'bold',
            borderColor: 'rgba(255, 255, 255, 1)',
            borderWidth: '2px',
            borderRadius: '20px',
            justifyContent: 'center',
            backgroundColor: 'rgba(133, 0, 27, 1)',
          })
          customBtn.settings.action = 'wheelSpin'
          customBtn.settings.backBtn = false
          return customBtn
        })(),
        // spacer
        (() => {
          const customSpacer = JSON.parse(JSON.stringify(spacer))
          customSpacer.styling.padding = '8px'
          return customSpacer
        })(),
      ],
    },
    {
      id: 'gv9cgi4',
      contentItems: [
        (() => {
          const customImage = JSON.parse(JSON.stringify(image))
          customImage.content.url = 'https://assets.onvocado.com/templates/black_friday_tag.png'
          Object.assign(customImage.styling, {
            backgroundSize: 'cover',
            backgroundColor: 'rgba(0, 0, 0, 0)',
            backgroundPosition: 'center',
          })
          return customImage
        })(),
        (() => {
          const customSpacer = JSON.parse(JSON.stringify(spacer))
          customSpacer.styling.padding = '8px'
          return customSpacer
        })(),
        (() => {
          const customHeadline = JSON.parse(JSON.stringify(headline))
          customHeadline.content.text = 'Congratulations, you won!'
          Object.assign(customHeadline.styling, {
            fontFamily: 'Inter',
            fontSize: '40px',
            fontWeight: 'bold',
            color: 'rgba(255, 255, 255, 1)',
            textAlign: 'center',
          })
          return customHeadline
        })(),
        // text
        (() => {
          const customText = JSON.parse(JSON.stringify(text))
          customText.content.text = 'Don\'t forget to copy your voucher code and use it at checkout!'
          Object.assign(customText.styling, {
            color: 'rgba(255, 255, 255, 1)',
            fontSize: '18px',
            textAlign: 'left',
            fontFamily: 'Inter',
            fontWeight: '400',
          })
          return customText
        })(),
        // spacer
        (() => {
          const customSpacer = JSON.parse(JSON.stringify(spacer))
          customSpacer.styling.padding = '8px'
          return customSpacer
        })(),
        // voucher
        (() => {
          const customVoucher = JSON.parse(JSON.stringify(voucher))
          customVoucher.content.text = 'VOUCHER CODE'
          Object.assign(customVoucher.styling, {
            color: 'rgba(255, 255, 255, 1)',
            borderColor: 'rgba(255, 255, 255, 1)',
            borderRadius: '20px',
            fontSize: '26px',
            fontWeight: 'bold',
            textAlign: 'center',
            fontFamily: 'Inter',
          })
          return customVoucher
        })(),
        // spacer
        (() => {
          const customSpacer = JSON.parse(JSON.stringify(spacer))
          customSpacer.styling.padding = '60px'
          return customSpacer
        })(),
      ],
    },
  ],
}

export { json, info }
